import { useTranslation } from "../../i18n/useTranslation";

/**
 * A PAY SCREEN WHOSE CHUNK COULD NOT LOAD, AFTER THE BOOKING ANSWER (W6
 * condition (b); Web Director, 2026-10-20). The answer has come back, so the
 * route's generic failure would be a wrong state, and a retry would be a
 * second press. A failed import() also poisons its URL for the page's life, so
 * reloading the chunk is no recovery. The approved pointer instead: the result
 * is in the email and on the appointment link (the guest's, when the answer
 * carried one). Nothing is sent, and the tab's checkout record is left as it
 * is, for /checkout/return.
 *
 * Its words are in the ENTRY track (i18n/messages/pay.ts): the lazy pay
 * chunks' words arrive with those chunks, which this is the fallback for.
 */
export function PayChunkFallback({ manageUrl }: { manageUrl?: string | null }) {
  // Not compiled (the entry budget, W6): a leaf rendered at most once, after
  // a failed chunk, has nothing to memoise.
  "use no memo";
  const { t } = useTranslation();
  return (
    <div className="b3-pay-chunk-fallback" role="status" data-testid="pay-chunk-fallback">
      <p className="b-p">{t("pay.return.otherBrowser")}</p>
      {manageUrl ? (
        /* A BEARER CREDENTIAL in one href and nowhere else, as BookingOutcome. */
        <a className="b-btn v-primary is-full" href={manageUrl} rel="noreferrer" data-testid="pay-chunk-fallback-manage">
          {t("guest.manage.confirmed")}
        </a>
      ) : null}
    </div>
  );
}

